module.exports = __webpack_public_path__ + "img/coronagirlen.fbba4cc3.svg";